import { SessionListComponent } from '../shared/components/session-list/session-list.component';
import { SessionCollectionComponent } from '../shared/components/session-collection/session-collection.component';
import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';
import { AppRoutingModule } from '../app-routing.module';
import { MessageService } from 'primeng/api';

import { MatTabsModule } from '@angular/material/tabs';

import { StaffRoutingModule } from './staff.routing.module';
import { StaffMainComponent, StaffHomeComponent } from './';
import { PatientSessionService } from './home/patient-session.service';
import { TargetBoxesModule } from './home/target-boxes.module';
import { EndSessionComponent } from './home/end-session/end-session.component';
import { SessionsComponent } from './sessions/sessions.component';
import { SessionServiceSelectComponent } from './sessions/session-service-select/session-service-select.component';
import { ViewSessionComponent } from './sessions/view-session/view-session.component';
import { GraphsModule } from '../graphs/graphs.module';
import { ProgressNoteComponent } from './home/progress-note/progress-note.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { AddDataComponent } from './sessions/add-data/add-data.component';
import { AddBehaviorDataComponent } from './sessions/add-behavior-data/add-behavior-data.component';
import { AddTargetDataComponent } from './sessions/add-target-data/add-target-data.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectButtonModule } from 'primeng/selectbutton';
import { BehaviorBipInfoComponent } from '../supervisor/behaviors/behavior-bip-info/behavior-bip-info.component';
import { BipQuickReferenceComponent } from '../supervisor/bip/bip-quick-reference/bip-quick-reference.component';
import { BipBehaviorsComponent } from '../supervisor/bip/bip-behaviors/bip-behaviors.component';
import { BipCrisisCycleComponent } from '../supervisor/bip/bip-crisis-cycle/bip-crisis-cycle.component';
import { BipEmergencyProceduresComponent } from '../supervisor/bip/bip-emergency-procedures/bip-emergency-procedures.component';
import { BipAdditionalInfoComponent } from '../supervisor/bip/bip-additional-info/bip-additional-info.component';
import { GroupSessionComponent } from './group-session/group-session.component';
import { TargetNoteThreadComponent } from '../shared/components/target-note-thread/target-note-thread.component';

function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(
      `${moduleName} has already been loaded. Import Core modules in the AppModule only.`
    );
  }
}

const pages = [StaffMainComponent, StaffHomeComponent];

@NgModule({
  imports: [
    CommonModule,
    SessionCollectionComponent, SessionListComponent,
    FormsModule,
    SharedModule,
    StaffRoutingModule,
    MatTabsModule,
    GraphsModule,
    OverlayPanelModule,
    TableModule,
    ToolbarModule,
    FileUploadModule,
    MultiSelectModule,
    InputNumberModule,
    SelectButtonModule,
    BehaviorBipInfoComponent,
    BipQuickReferenceComponent,
    BipBehaviorsComponent,
    BipCrisisCycleComponent,
    BipEmergencyProceduresComponent,
    BipAdditionalInfoComponent,
    TargetNoteThreadComponent,
    TargetBoxesModule,
  ],
  declarations: [
    ...pages,
    EndSessionComponent,
    SessionsComponent,
    SessionServiceSelectComponent,
    ViewSessionComponent,
    ProgressNoteComponent,
    AddDataComponent,
    AddBehaviorDataComponent,
    AddTargetDataComponent,
    GroupSessionComponent,
  ],
  exports: [AddDataComponent, AddBehaviorDataComponent, AddTargetDataComponent],
  bootstrap: [],
})
export class StaffModule {
  constructor(@Optional() @SkipSelf() parentModule: StaffModule) {
    if (parentModule) {
      throw new Error(
        'Module is already loaded. Import in your base AppModule only.'
      );
    }
  }
}
